//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Group Requirements Filter */
export const GroupRequirementsFilter = {
    /** Ignore */
    Ignore: 0,

    /** Must Meet */
    MustMeet: 1,

    /** Does Not Meet */
    DoesNotMeet: 2
} as const;

/** Group Requirements Filter */
export const GroupRequirementsFilterDescription: Record<number, string> = {
    0: "Ignore",

    1: "Must Meet",

    2: "Does Not Meet"
};

/** Group Requirements Filter */
export type GroupRequirementsFilter = typeof GroupRequirementsFilter[keyof typeof GroupRequirementsFilter];
